import { render, staticRenderFns } from "./AppContent.vue?vue&type=template&id=9b2aa6a8&scoped=true&"
import script from "./AppContent.vue?vue&type=script&lang=js&"
export * from "./AppContent.vue?vue&type=script&lang=js&"
import style0 from "./AppContent.vue?vue&type=style&index=0&id=9b2aa6a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b2aa6a8",
  null
  
)

export default component.exports